export default "__VITE_ASSET__C5GSg37u__"